import { lazy } from "react";

import Training from "../_globalConfiguration/HealthSafetyEnvironment/Training/Training";
import IncidentManagement from "./IncidentManagement/IncidentManagement";
import TrainingManagement from "./TrainingManagement/TrainingManagement";
import EHSAuditsMeetings from "./EHSAuditsMeetings/EHSAuditsMeetings";

// Investigator

//import ManageIncidentReport from "./IncidentManagement/manageIncidentReport";
// import ManageIncidentReport from "./IncidentManagement/ManageIncidentReport";
import IncidentReportForm from "./IncidentManagement/IncidentReportForm";
import IncidentInvestigationForm from "./IncidentManagement/IncidentInvestigationForm";

//Training Management Module
import Assign from "./TrainingManagement/Assign/Assign";
import TrainingStatus from "./TrainingManagement/TrainingStatus/TrainingStatus";
import TrainingBatches from "./TrainingManagement/TrainingBatches/TrainingBatches";
import TrainingApprovalActions from "./TrainingManagement/MyApprovalActions/MyApprovalActions";
import TrainingApprovalHistory from "./TrainingManagement/MyApprovalHistory/MyApprovalHistory";
import TrainingCalendar from "./TrainingManagement/TrainingCalendar/TrainingCalendar";
import AssignNewTraining from "./TrainingManagement/Assign/AssignNewTraining";
import ManageIncidents from "./IncidentManagement/ManageIncidents";
import MyIncidents from "./IncidentManagement/MyIncidents";
import IncidentReviewForm from "./IncidentManagement/IncidentReviewForm";
import UpdateCapa from "./CapaManagement/UpdateCapa";
import ScheduledEvent from "./EHSAuditsMeetings/ScheduledEvent";
import ViewCAPA from "./CapaManagement/ViewCAPA";
import ViewScheduler from "./EHSAuditsMeetings/ViewScheduler";
import MeetingsCalendar from "./EHSAuditsMeetings/MeetingsCalendar";
import ViewTasks from "./EHSAuditsMeetings/ViewTasks";
import ViewOwner from "./EHSAuditsMeetings/ViewOwner";
import AddUpdateMeeting from "./EHSAuditsMeetings/AddUpdateMeeting";
import CapaManagement from "./CapaManagement/CapaManagement";
import ManageCapa from "./CapaManagement/ManageCapa";

import ViewIncidentReport from "./IncidentManagement/ViewIncidentReport";
import ViewIncidentInvestigation from "./IncidentManagement/ViewIncidentInvestigation";
import ViewIncidentReview from "./IncidentManagement/ViewIncidentReview";
import EditMeetingDetails from "./EHSAuditsMeetings/EditMeetingDetails";

import VFLSchedule from "./VFL/VFLSchedule";
import VFL from "./VFL/VFL";
import MyVFL from "./VFL/MyVFL";
import ManageVFL from "./VFL/ManageVFL";
import VFLCompletionForm from "./VFL/VFLCompletionForm";
import VFLSOForm from "./VFL/VFLSOForm";
import VFLMMForm from "./VFL/VFLMMForm";
import VFLCalendar from "./VFL/VFLCalendar";
import VFLVIew from "./VFL/VFLVIew";
import TrainingView from "./TrainingManagement/TrainingView";
import FormAManagement from "./FormAManagement/FormAManagement";

import ViewIncident from "./IncidentManagement/ViewIncident";
import MyApprovalAction from "./IncidentManagement/MyApprovalAction";
import MyApprovalHistory from "./IncidentManagement/MyApprovalHistory";
import MyApprovalActionVFL from "./VFL/MyApprovalActionVFL";
import MyApprovalHistoryVFL from "./VFL/MyApprovalHistoryVFL";
import ViewVFLCompletion from "./VFL/ViewVFLCompletion";
import MedicalExamDue from "./Medical/MedicalExamDue";
import MyApprovalActionMedical from "./Medical/MyApprovalActionMedical";
import MyApprovalHistoryMedical from "./Medical/MyApprovalHistoryMedical";
import ViewMedicalData from "./Medical/ViewMedicalData";
import MyApprovalActionOHSE from "./EHSAuditsMeetings/MyApprovalActionOHSE";
import ViewOHSE from "./EHSAuditsMeetings/ViewOHSE";
import MyApprovalHistoryOHSE from "./EHSAuditsMeetings/MyApprovalHistoryOHSE";
import MyOHSE from "./EHSAuditsMeetings/MyOHSE";
import RevertCapaUpdate from "./CapaManagement/RevertCapaUpdate";
import RevertTaskUpdate from "./EHSAuditsMeetings/RevertTaskUpdate";
import ViewIncidentReportsReview from "../Reports/IncidentReports/ViewIncidentReportsReview";
import ViewVflReports from "../Reports/VflReports/ViewVflReports";
import ViewPmeScheduleList from "./Medical/ViewPmeScheduleList";
import LtiUpdateForm from "./IncidentManagement/Component/LtiUpdateForm";
import ViewDoneMedicalData from "./Medical/ViewDoneMedicalData";
import TrainingAll from "./TrainingManagement/TrainingStatus/TrainingAll";
import ViewInActiveStaffMedical from "./Medical/ViewInActiveStaffMedical";
import ViewInActiveStaffTraining from "./TrainingManagement/TrainingStatus/ViewInActiveStaffTraining";
import PersonalInfo from "./PersonalInfo/PersonalInfo";

/****** Medical Routes *****/

const Medical = lazy(() => import("./Medical/Medical"));
const ManageMedical = lazy(() => import("./Medical/ManageMedical"));
const AddMedical = lazy(() => import("./Medical/AddMedical"));
const ViewMedical = lazy(() => import("./Medical/ViewMedical"));

const HealthSafetyEnvironmentRoutes = [
  /*CAPA Management*/
  {
    path: "/health-safety-and-environment/capa-management",
    component: CapaManagement,
    nav: 1,
    exact: true,
  },
  {
    path: "/health-safety-and-environment/capa-management/manage-capa",
    component: ManageCapa,
    nav: 1,
    exact: true,
  },
  {
    path: "/health-safety-and-environment/capa-management/manage-capa/view/:id",
    component: ViewCAPA,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/capa-management/manage-capa/update/:id",
    component: UpdateCapa,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/capa-management/manage-capa/capa-update/:id",
    component: RevertCapaUpdate,
    nav: 1,
  },

  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/edit/:id",
    component: EditMeetingDetails,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/:id",
    component: EditMeetingDetails,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event/edit/:id",
    component: AddUpdateMeeting,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event/view/:id",
    component: ViewScheduler,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event/add/:eventId",
    component: AddUpdateMeeting,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/scheduled-event",
    component: ScheduledEvent,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/calendar",
    component: MeetingsCalendar,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/my-approval",
    component: MyApprovalActionOHSE,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/my-approval-history",
    component: MyApprovalHistoryOHSE,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/my-events",
    component: MyOHSE,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/views",
    component: ViewOHSE,
    nav: 1,
  },
  // {
  //   path: "/health-safety-and-environment/audits-meetings/my-approval-history",
  //   component: MyApprovalActionOHSE,
  //   nav: 1,
  // },
  {
    path: "/health-safety-and-environment/audits-meetings",
    component: EHSAuditsMeetings,
    nav: 1,
    exact: true,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/view-tasks",
    component: ViewTasks,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/view-owner/:viewId",
    component: ViewOwner,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/edit-owner/:editId",
    component: ViewOwner,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/audits-meetings/update-task/:id",
    component: RevertTaskUpdate,
    nav: 1,
  },

  /* View Incident pages */
  {
    path: "/health-safety-and-environment/incident-management",
    component: IncidentManagement,
    nav: 1,
    exact: true,
  },
  {
    path: "/health-safety-and-environment/incident-management/manage-incidents",
    component: ManageIncidents,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/view-incidents",
    component: ViewIncident,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/update-lti-info/:id",
    component: LtiUpdateForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/my-approval-incidents",
    component: MyApprovalAction,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/my-approval-history-incidents",
    component: MyApprovalHistory,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/my-incidents",
    component: MyIncidents,
    nav: 1,
  },

  /* End */

  {
    path: "/health-safety-and-environment/incident-management/report/add",
    component: IncidentReportForm,
    permission: ["reporterOfficer"],
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/report/edit/:id",
    component: IncidentReportForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/report/view/:id",
    component: ViewIncidentReport,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/investigation/view/:id",
    component: ViewIncidentInvestigation,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/investigation/edit/:id",
    component: IncidentInvestigationForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-management/review/view/:id",
    component: ViewIncidentReview,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/incident-reports/review/view/:id",
    component: ViewIncidentReportsReview,
    nav: 1,
  },
  // {
  //   path: "/reports/vfl/view/:id",
  //   component: ViewVflReports,
  //   nav: 1,
  // },
  {
    path: "/health-safety-and-environment/incident-management/review/edit/:id",
    component: IncidentReviewForm,
    nav: 1,
  },
  {
    path: "/global-configuration/health-safety-and-environment/training",
    component: Training,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/assign/assign-new-training",
    permission: ["vto"],
    component: AssignNewTraining,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/assign/assign-training/edit/:id",
    permission: ["vto"],
    component: AssignNewTraining,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/assign",
    permission: ["vto"],
    component: Assign,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/status",
    component: TrainingStatus,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/view-inactive-staff-training",
    component: ViewInActiveStaffTraining,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/all-training",
    component: TrainingAll,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/batches",
    component: TrainingBatches,
    permission: ["vto"],
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/calendar",
    component: TrainingCalendar,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/approval-history",
    component: TrainingApprovalHistory,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/approval-actions",
    component: TrainingApprovalActions,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management/view/:id",
    component: TrainingView,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/training-management",
    component: TrainingManagement,
    nav: 1,
    exact: true,
  },

  /******* VFL *******/
  {
    path: "/health-safety-and-environment/vfl/completion/view/:id",
    component: ViewVFLCompletion,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/completion/:id",
    component: VFLCompletionForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/view/:id",
    component: VFLVIew,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/my-approval-incidents",
    component: MyApprovalActionVFL,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/my-approval-history-incidents",
    component: MyApprovalHistoryVFL,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/so-completion/:id",
    component: VFLSOForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/mm-completion/:id",
    component: VFLMMForm,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/calendar",
    component: VFLCalendar,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/schedule/:id",
    component: VFLSchedule,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/schedule",
    component: VFLSchedule,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/manage",
    component: ManageVFL,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl/my",
    component: MyVFL,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/vfl",
    component: VFL,
    nav: 1,
  },

  /******* Medical *******/
  {
    path: "/health-safety-and-environment/medical/view/:id",
    component: ViewMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/edit/:id",
    component: AddMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/view/:id",
    component: AddMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/add",
    component: AddMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/manage",
    component: ManageMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/exam-due",
    component: MedicalExamDue,
    permission: ["medicalOfficer"],
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/my-action",
    component: MyApprovalActionMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/approval-history",
    component: MyApprovalHistoryMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/view-medical-data",
    component: ViewMedicalData,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/view-done-medical-data",
    component: ViewDoneMedicalData,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/view-inactive-staff-medical",
    component: ViewInActiveStaffMedical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical/view-pme-schedule",
    component: ViewPmeScheduleList,
    permission: ["superAdmin"],
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/medical",
    component: Medical,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/form-a-management",
    component: FormAManagement,
    exact: true,
    nav: 1,
  },
  {
    path: "/health-safety-and-environment/personal-info",
    component: PersonalInfo,
    exact: true,
    nav: 1,
    permission: ["superAdmin", "Form A Viewer", "Form A Editor"],
  },
];

export default HealthSafetyEnvironmentRoutes;
